import {equalsAnyIgnoreCase, equalsIgnoreCase} from './lang';
import {ROLES} from '../_constants/constants';
import {UserPermissions} from '../_data/admin/permissions';

/**
 * Converts the roles and product indicator into an easy to use map.
 *
 * @param pi - The product indicator flag
 * @param roles - The user's ldap roles
 */
export function toUserPermissions(pi: string, roles: string[]): UserPermissions {
  const userTypeMap: UserPermissions = {admin: false, business: false, consumer: false, operator: false, tuAdmin: false};

  //Check each role and set the userType flag if appropriate
  roles.forEach(role => {
    if(isAdminRole(role, 'tu-admin')) {
      userTypeMap.tuAdmin = true;
    }
    if(isAdminRole(role, 'admin')) {
      userTypeMap.admin = true;
    }
    if(isOperatorRole(role)) {
      userTypeMap.operator = true;
    }
  });

  //Assign the userType flags based on the product indicator, which is for business/consumer parts of the site instead of the roles
  userTypeMap.business = equalsAnyIgnoreCase(pi, 'both', 'business');
  userTypeMap.consumer = equalsAnyIgnoreCase(pi, 'both', 'consumer');

  return userTypeMap;
}

export function isUserRole(role: string): boolean {
  return equalsAnyIgnoreCase(role, ...ROLES.regularUser);
}

/**
 * Verifies the given role corresponds to the admin label.
 *
 * @see 'tu-admin': {@link ROLES.tuAdmin}, 'admin': {@link ROLES.companyAdmin}
 */
export function isAdminRole(role: string, adminType: 'admin' | 'tu-admin'): boolean {
  // A TU admin would be a yes regardless, and a company admin we need to verify the caller is asking for 'admin' adminType
  return equalsAnyIgnoreCase(role, ...ROLES.tuAdmin) || (equalsIgnoreCase(adminType, 'admin') && equalsAnyIgnoreCase(role, ...ROLES.companyAdmin));
}

export function isOperatorRole(role: string): boolean {
  return equalsAnyIgnoreCase(role, ...ROLES.operator);
}
